export const softError = (errorMsg) => {
  if (process.env.NODE_ENV === "production") {
    console.warn(errorMsg);
  } else {
    throw Error(errorMsg);
  }
};
